import { Component } from '@angular/core';
import { ActiveSessions } from './active-sessions.model';
import { RouterConst } from '../../../globals/RoutersConst';
import { BreadcrumbService } from '../../../breadcrumb.service';
import { ClientsService } from '../../../services/clients/clients.service';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { DashboardDataService } from '../../../services/dashboard-data.service';
import { WsService } from '../../../services/websocket/WsService';
import { SuperClass } from '../../../superclass/SuperClass';

@Component({
  selector: 'app-active-sessions',
  templateUrl: './active-sessions.component.html',
  styleUrls: ['./active-sessions.component.css'],
})
export class ActiveSessionsComponent extends SuperClass {
  selectedRow: ActiveSessions;
  display = false;
  start: Date;
  end: Date;
  venueCode;
  nasid;
  sessions: ActiveSessions[];
  loading:string = 'none';

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Sessions' },
      {
        label: 'Active Sessions',
        routerLink: [
          { outlets: { sub: [RouterConst.SESSIONS_ACTIVE_SESSIONS] } },
        ],
      },
    ]);
    this.selectedRow = new ActiveSessions();
  }

  reloadData() {
    this.end = new Date();
    this.start = new Date(this.end.getTime() - 24 * 60 * 60 * 1000);
    this.nasid = '';
    this.getActiveSessions();
  }

  getDate(date) {
    if (date) {
      return new Date(date);
    }
  }

  selectRow(e) {
    this.selectedRow = new ActiveSessions(e.data);
  }

  getActiveSessions() {
    const request = {
      start: this.start.getTime(),
      end: this.end.getTime(),
      nasid: this.nasid,
    };
    this.loading = 'block';
    this.http_getAllActiveSessions(request, (response: any) => {
      this.sessions = response.payload;
      this.loading = 'none';
    });
  }

  unselectRow() {}

  getWebSocketIdentifier(): string {
    return undefined;
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/sessions/active-sessions/active-sessions.component.ts